import React, { useState } from 'react';
import { X, Table } from 'lucide-react';
import { formatCurrency } from '../../../utils/formatters';

interface SensitivityAnalysisProps {
  onClose: () => void;
  baseValue: number;
}

export default function SensitivityAnalysis({ onClose, baseValue }: SensitivityAnalysisProps) {
  const [growthRates] = useState([-2, -1, 0, 1, 2]);
  const [multiples] = useState([8, 9, 10, 11, 12]);

  const calculateValue = (growth: number, multiple: number) => {
    return baseValue * (1 + growth / 100) * multiple;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">Sensitivity Analysis</h3>
          <button onClick={onClose}>
            <X className="w-5 h-5 text-gray-400 hover:text-gray-600" />
          </button>
        </div>

        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Growth Rate (%) / Multiple
                  </th>
                  {multiples.map(multiple => (
                    <th key={multiple} className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {multiple}x
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {growthRates.map(growth => (
                  <tr key={growth}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {growth}%
                    </td>
                    {multiples.map(multiple => (
                      <td key={multiple} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {formatCurrency(calculateValue(growth, multiple))}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}